export function fmtWan(n: number): string {
  if (n >= 10000) {
    const v = n / 10000;
    return `${v % 1 === 0 ? v : v.toFixed(1)}万`;
  }
  return String(n);
}